import { useState } from "react";
import BookActivity from "components/feed/BookActivity";
import PromptType from "types/PromptType";
import Text from "hardcover-ui/components/Text";
import TextLink from "hardcover-ui/components/TextLink";
import BookGroupBooks from "components/BookGroup/books/BookGroupBooks";
import ActivityProps from "./ActivityFeedItemProps";
import { BookSerializersBookByline } from "types/serializers";

interface PromptActivityDataType {
  prompt: PromptType;
}

export default function PromptActivityActivity({ activity }: ActivityProps) {
  const [prompt] = useState((activity.data as PromptActivityDataType).prompt);
  const books = prompt.answers.map((promptAnswer) => promptAnswer.book);

  return (
    <div className="p-2 space-y-4">
      <BookActivity activity={activity}>
        <p className="text-lg">
          <Text variant="secondary">Answered a prompt</Text>
          <TextLink
            className="block"
            size="xl"
            underline={false}
            href={`/prompts/${prompt.slug}`}
          >
            {prompt.question}
          </TextLink>
        </p>
      </BookActivity>

      {books.length >= 3 && (
        <BookGroupBooks
          size="md"
          books={books.slice(0, 7) as unknown as BookSerializersBookByline[]}
          context={{
            activeBook: activity.book,
          }}
        />
      )}
    </div>
  );
}
